<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead"><a id="page_v"><span class="bold">Contents</span></a></h1><a id="page_v">
</a><h2 class="tocli"><a id="page_v"></a><a href="#/xhtml/04_acknowledgements">Acknowledgements</a></h2>
<h2 class="tocli"><a href="#/xhtml/05_foreword">Foreword</a></h2>
<h2 class="tocli"><a href="#/xhtml/06_introduction">Introduction by Dan Brookes</a></h2>
<h2 class="tocli"><a href="#/xhtml/07_chapter_01">A Life-Changing Experience by Bob Hillerby</a></h2>
<h2 class="tocli"><span href="#/xhtml/08_chapter_02" title="Link target outside of Sample">A Million-Dollar Experience by Dan Brookes</span></h2>
<h2 class="tocli"><span href="#/xhtml/09_chapter_03" title="Link target outside of Sample">Lessons Not Learned – My Lai Revisited</span></h2>
<h2 class="tocli"><span href="#/xhtml/10_chapter_04" title="Link target outside of Sample">The Story of a US Army Combat Correspondent</span></h2>
<h2 class="tocli"><span href="#/xhtml/11_chapter_05" title="Link target outside of Sample">Vietnam Was Also a <em class="italic">Country</em> – Photographs of a People and a Culture</span></h2>
<h2 class="tocli"><span href="#/xhtml/12_chapter_06" title="Link target outside of Sample">Parting Shots – Afterword</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?e9e80e6a